export default __webpack_public_path__ + "static/media/pyszne-sm.f2d2fc50.svg";